import { observer } from 'mobx-react-lite'
import { Outlet } from 'react-router'
import { useRootStore } from '@/contexts/root-store-context'
import { useReactRouterGaReporter } from '@/features/tracking/tracking-hooks'
import { AlertsHostContainer } from '@/features/shell/alerts/components/AlertsHost/AlertsHostContainer'
import { AppLayout } from '@/features/shell/components/AppLayout'

export const AppContainer = observer(function AppContainer() {
  const { shell } = useRootStore()
  useReactRouterGaReporter()

  return (
    <>
      <AppLayout>
        <Outlet />
      </AppLayout>

      <AlertsHostContainer manager={shell.internal.alertsManager} />
    </>
  )
})
